module.exports = __webpack_public_path__ + "static/img/404.1f57eaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/404.png
// module id = 381
// module chunks = 1